import { Grid, PargodaRoundButton, Typography, useTheme } from '../../base';
import { useTranslation } from 'react-i18next';
import { ResetPasswordFormWrapper } from './PasswordEmailSent.styles';
import { useNavigate } from 'react-router-dom';
import { Directions } from '../../common';

// Add Props interface
interface Props {
    isMobile: boolean;
}

// Accept props
const PasswordEmailSent = ({ isMobile }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <ResetPasswordFormWrapper container>
            <Grid
                item
                xs={12}
                pt={3}
                pb={3.25}
                sx={{ textAlign: isMobile ? 'center' : 'left' }}
            >
                <Typography variant={'h4'} color={'primary'}>
                    {t('forgotPasswordPage.forgotPasswordEmailSentTitle')}
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
                pb={4}
                sx={{ textAlign: isMobile ? 'center' : 'left' }}
            >
                <Typography variant={'body1'}>
                    {t('forgotPasswordPage.forgotPasswordEmailSentDescription')}
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
                pb={4}
                // Align button center on mobile, keep original otherwise
                textAlign={
                    isMobile
                        ? 'center'
                        : theme.direction === Directions.rtl
                          ? 'left'
                          : 'right'
                }
            >
                <PargodaRoundButton
                    variant={'contained'}
                    sx={{
                        background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
                        // Conditionally set width
                        width: isMobile ? '100%' : undefined,
                    }}
                    onClick={() => {
                        navigate('/login');
                    }}
                >
                    {t('forgotPasswordPage.forgotPasswordEmailSentButtonText')}
                </PargodaRoundButton>
            </Grid>
        </ResetPasswordFormWrapper>
    );
};

export default PasswordEmailSent;
